<ndt-parkinglot-register-view
   [callState]="callState$ | async"
   [dataSource]="dataSource$ | async"
   [isLoading]="isLoading$ | async"
   [hasNextPage]="hasNextPage$ | async"
   [pagingCallState]="pagingCallState$ | async"
   [totalCount]="totalCount$ | async"
   [name]="entityName"
   [columns]="columns"
   [extensionsPrivileges]="extensionPrivileges$ | async"
   [isSystemUser]="isSystemUser$ | async"
   (loadMore)="onLoadMore()"
   (openDialog)="onOpenDialog($event)"
   (listen)="onListen($event)"
   (quickFilterChange)="onQuickFilterChange($event)"
></ndt-parkinglot-register-view>
